import { Component, Input, OnInit } from '@angular/core';
import { BackendAlarm } from '../../../../alarm/alarm-definitions/backend-alarm';
import { TrainDependencyAlarm } from '../../../../alarm/alarm-definitions/train-dependency.alarm';
import { AlarmMessage } from '../../../../alarm/alarm-message';
import { TabId } from '../../train-info/train-info/train-info.component';
import { getDefaultTabIdForAlarmType } from '../../utils/train.utils';

@Component({
  selector: 'qm-conflict-alarm-list-item',
  templateUrl: './conflict-alarm-list-item.component.html',
  styleUrls: ['./conflict-alarm-list-item.component.scss']
})
export class ConflictAlarmListItemComponent implements OnInit {

  @Input() public alarm: AlarmMessage<TrainDependencyAlarm>;

  public openTab: TabId = 'schedule';

  constructor() { }

  ngOnInit(): void {
    this.openTab = getDefaultTabIdForAlarmType(this.alarm?.metadata?.type);
  }

}
